import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextCompare = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_10052_25456",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_10052_25456)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.74984 18.846V17.0833H4.42296C4.00199 17.0833 3.64567 16.9375 3.354 16.6458C3.06234 16.3542 2.9165 15.9979 2.9165 15.5769V4.42313C2.9165 4.00216 3.06234 3.64584 3.354 3.35417C3.64567 3.0625 4.00199 2.91667 4.42296 2.91667H8.74984V1.15396H9.99984V18.846H8.74984ZM4.42296 15.8333H8.74984V13.75H6.0415V12.5H8.74984V10.625H6.0415V9.375H8.74984V7.5H6.0415V6.25H8.74984V4.16667H4.42296C4.3588 4.16667 4.30005 4.1934 4.24671 4.24688C4.19324 4.30021 4.1665 4.35896 4.1665 4.42313V15.5769C4.1665 15.641 4.19324 15.6998 4.24671 15.7531C4.30005 15.8066 4.3588 15.8333 4.42296 15.8333ZM11.7467 4.16667V2.91667H15.6569C16.0779 2.91667 16.4342 3.0625 16.7259 3.35417C17.0174 3.64584 17.1632 4.00216 17.1632 4.42313V15.5769C17.1632 15.9979 17.0174 16.3542 16.7259 16.6458C16.4342 16.9375 16.0779 17.0833 15.6569 17.0833H11.7467V15.8333H15.6569C15.7209 15.8333 15.7797 15.8066 15.8332 15.7531C15.8866 15.6998 15.9134 15.641 15.9134 15.5769V4.42313C15.9134 4.35896 15.8866 4.30021 15.8332 4.24688C15.7797 4.1934 15.7209 4.16667 15.6569 4.16667H11.7467ZM11.7467 10.625V9.375H14.455V10.625H11.7467ZM11.7467 7.5V6.25H14.455V7.5H11.7467Z",
			fill: "#064C68"
		})
	})]
});
export default SvgTextCompare;
